import { inject, Injectable } from '@angular/core';
import { PlatformService } from '@sml/utility';
import { map } from 'rxjs';
import { Observable } from 'rxjs/internal/Observable';
import { Subject } from 'rxjs/internal/Subject';

@Injectable({
  providedIn: 'root'
})
export class FormSpinnerService {
   private platformService = inject(PlatformService);

  private readonly formSpinnerVisible$ = new Subject<boolean>();

  public showFormSpinner(): void {
    this.formSpinnerVisible$.next(true);
  }

  public hideFormSpinner(): void {
    if(this.platformService.browser()){
      this.formSpinnerVisible$.next(false);
    }
  }

  public getFormSpinnerState(): Observable<boolean> {
    return this.formSpinnerVisible$.asObservable();
  }
}
